import {
    createRegisterableComponentWithData,
    ePaperReadersAlsoLoveDataDefinationLoader,
} from '@news-mono/web-common'
import React from 'react'
import { ReadersAlsoLove } from './ReadersAlsoLove'

export const ePaperPageReadersAlsoLoveRegistration =
    createRegisterableComponentWithData(
        'epaper-page-readers-also-love',
        ePaperReadersAlsoLoveDataDefinationLoader,
        (props, data, services) => {
            console.log(
                services.store.getState().meta.sectionMeta,
                'Epaper section meta',
            )
            if (data.loaded) {
                return <ReadersAlsoLove allEditions={data.result.issues} />
            }
            return null
        },
    )
